import { createSlice } from '@reduxjs/toolkit';
import { ThirdPartyFulfillmentSettingsResponse } from '../../../../pb/responses/v1/third_party_fulfillment_settings_response_pb';
import { getThirdPartyFulfillmentSettings } from './third-party-fulfillment-settings.actions';

export interface ThirdPartyFulfillmentSettingsState {
    data: ThirdPartyFulfillmentSettingsResponse | null;
    fetching: boolean;
    error: boolean;
}

const initialState: ThirdPartyFulfillmentSettingsState = {
    data: null,
    fetching: false,
    error: false,
};

const thirdPartyFulfillmentSettingsSlice = createSlice({
    name: 'thirdPartyFulfillmentSettings',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getThirdPartyFulfillmentSettings.pending, (state) => {
                state.fetching = true;
                state.error = false;
            })
            .addCase(getThirdPartyFulfillmentSettings.fulfilled, (state, action) => {
                state.data = action.payload;
                state.fetching = false;
            })
            .addCase(getThirdPartyFulfillmentSettings.rejected, (state) => {
                state.fetching = false;
                state.error = true;
            });
    },
});

export default thirdPartyFulfillmentSettingsSlice.reducer;
